<!-- Tabs -->
<div class="tabs-container">
  <div class="tabs-header">
    <div class="tabs-buttons">
      <button 
        class="tab-button" 
        [class.active]="activeTab === 'approved'"
        (click)="setActiveTab('approved')"
      >
        Approved
      </button>
      <button 
        class="tab-button" 
        [class.active]="activeTab === 'pending'"
        (click)="setActiveTab('pending')"
      >
        Pending
      </button>
      <button 
        class="tab-button" 
        [class.active]="activeTab === 'rejected'"
        (click)="setActiveTab('rejected')"
      >
        Rejected
      </button>
    </div>
    <div class="tabs-total">
      Total Count: <span class="tabs-total-value">{{ totalTabCount }}</span>
    </div>
  </div>
</div>

<!-- Expand Cell Template -->
<ng-template #publishAssetExpandCell let-row>
  <button 
    class="expand-btn"
    (click)="toggleRowExpansion(row)"
    [attr.aria-expanded]="isRowExpanded(row)"
    type="button"
  >
    <svg 
      width="16" 
      height="16" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      [style.transform]="isRowExpanded(row) ? 'rotate(90deg)' : 'rotate(0deg)'"
      [style.transition]="'transform 0.2s ease'"
    >
      <path 
        d="M9 18L15 12L9 6" 
        stroke="currentColor" 
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round"
      />
    </svg>
  </button>
</ng-template>

<!-- Child Row Template -->
<ng-template #publishAssetChildRow let-row>
  <tr class="table--child-row">
    <td [attr.colspan]="publishAssetColumns.length" class="table--child-cell">
      <div class="child-row-content">
        <div class="child-row-grid">
          <div class="child-row-item">
            <span class="child-row-label">Uploaded By</span>
            <span class="child-row-value">{{ row.originalData?.uploadedBy || '-' }}</span>
          </div>
          <div class="child-row-item">
            <span class="child-row-label">Industry</span>
            <span class="child-row-value">{{ row.originalData?.industry || '-' }}</span>
          </div>
          <div class="child-row-item">
            <span class="child-row-label">Organization</span>
            <span class="child-row-value">{{ row.originalData?.organization || '-' }}</span>
          </div>
        </div>
      </div>
    </td>
  </tr>
</ng-template>

<app-table
  [columns]="publishAssetColumns"
  [data]="publishAssetData"
  [pagination]="publishAssetPagination"
  [loading]="publishAssetLoading"
  [emptyMessage]="publishAssetEmptyMessage"
  [dropdownOpenRowIndex]="openPublishAssetDropdownRowIndex"
  [childRowTemplate]="publishAssetChildRowTemplate"
  [isRowExpanded]="getIsRowExpanded()"
  [initialSortColumn]="currentSort.field"
  [initialSortDirection]="currentSort.order"
  (pageChange)="onPublishAssetPageChange($event)"
  (pageSizeChange)="onPublishAssetPageSizeChange($event)"
  (sortChange)="onPublishAssetSortChange($event)"
>
  <!-- Permission column: chips with icon -->
  <ng-template #publishAssetPermissionCell let-row>
    <span [ngClass]="getPermissionChipClass(row.permission)" class="contribution-chip contribution-chip--with-icon">
      <svg class="contribution-chip--permission-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 2C15.31 2 18.23 3.69 20.35 6.26C20.43 6.37 20.5 6.49 20.57 6.61C20.64 6.73 20.71 6.85 20.78 6.97C20.85 7.09 20.91 7.21 20.97 7.33C21.03 7.45 21.08 7.57 21.13 7.69C21.18 7.81 21.23 7.93 21.27 8.05C21.31 8.17 21.35 8.29 21.38 8.41C21.41 8.53 21.44 8.65 21.46 8.77C21.48 8.89 21.5 9.01 21.51 9.13C21.52 9.25 21.52 9.37 21.52 9.49C21.52 9.61 21.52 9.73 21.51 9.85C21.5 9.97 21.48 10.09 21.46 10.21C21.44 10.33 21.41 10.45 21.38 10.57C21.35 10.69 21.31 10.81 21.27 10.93C21.23 11.05 21.18 11.17 21.13 11.29C21.08 11.41 21.03 11.53 20.97 11.65C20.91 11.77 20.85 11.89 20.78 12.01C20.71 12.13 20.64 12.25 20.57 12.37C20.5 12.49 20.43 12.61 20.35 12.72C18.23 15.29 15.31 17 12 17C8.69 17 5.77 15.29 3.65 12.72C3.57 12.61 3.5 12.49 3.43 12.37C3.36 12.25 3.29 12.13 3.22 12.01C3.15 11.89 3.09 11.77 3.03 11.65C2.97 11.53 2.92 11.41 2.87 11.29C2.82 11.17 2.77 11.05 2.73 10.93C2.69 10.81 2.65 10.69 2.62 10.57C2.59 10.45 2.56 10.33 2.54 10.21C2.52 10.09 2.5 9.97 2.49 9.85C2.48 9.73 2.48 9.61 2.48 9.49C2.48 9.37 2.48 9.25 2.49 9.13C2.5 9.01 2.52 8.89 2.54 8.77C2.56 8.65 2.59 8.53 2.62 8.41C2.65 8.29 2.69 8.17 2.73 8.05C2.77 7.93 2.82 7.81 2.87 7.69C2.92 7.57 2.97 7.45 3.03 7.33C3.09 7.21 3.15 7.09 3.22 6.97C3.29 6.85 3.36 6.73 3.43 6.61C3.5 6.49 3.57 6.37 3.65 6.26C5.77 3.69 8.69 2 12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>{{ getPermissionLabel(row.permission) }}</span>
    </span>
  </ng-template>
  <!-- Published On: DD-MMM-YYYY -->
  <ng-template #publishAssetPublishedOnCell let-row>
    {{ formatPublishedOn(row.publishedOn) }}
  </ng-template>
  <!-- Custom Action Column -->
  <ng-template #publishAssetActionCell let-row>
    <div class="action-cell-wrapper" [class.action-dropdown-open]="isDropdownOpen(row)">
      <button 
        class="action-btn action-btn--primary" 
        appActionDropdownTrigger
        (click)="toggleActionDropdown($event, row)"
        [class.active]="isDropdownOpen(row)"
        type="button"
      >
        <span class="action-btn-label">Action</span>
        <svg class="action-btn-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>
      <div 
        class="action-dropdown-menu action-dropdown-menu--fixed" 
        *ngIf="isDropdownOpen(row)" 
        [style.top.px]="dropdownPosition.top"
        [style.left.px]="dropdownPosition.left"
        [style.right.px]="dropdownPosition.right"
        (click)="$event.stopPropagation()"
      >
        <ul class="dropdown-list">
          <li class="dropdown-item" *ngIf="showPublishAssetAction('view')">
            <button class="dropdown-link" (click)="handleAction('view', row)">View</button>
          </li>
          <li class="dropdown-item" *ngIf="showPublishAssetAction('approve')">
            <button class="dropdown-link" (click)="handleAction('approve', row)">Approve</button>
          </li>
          <li class="dropdown-item" *ngIf="showPublishAssetAction('reject')">
            <button class="dropdown-link" (click)="handleAction('reject', row)">Reject</button>
          </li>
          <li class="dropdown-item" *ngIf="showPublishAssetAction('modify')">
            <button class="dropdown-link" (click)="handleAction('modify', row)">Modify asset</button>
          </li>
          <li class="dropdown-item" *ngIf="showPublishAssetAction('delete')">
            <button class="dropdown-link" (click)="handleAction('delete', row)">Delete asset</button>
          </li>
        </ul>
      </div>
    </div>
  </ng-template>
</app-table>

<!-- Delete Asset Confirmation -->
<app-confirmation-dialog
  [(visible)]="showDeleteConfirmModal"
  type="delete"
  themeColor="red"
  title="Delete Asset"
  [message]="rowToDelete ? 'Are you sure you want to delete &quot;' + (rowToDelete.assetName || 'this asset') + '&quot;? This action cannot be undone.' : ''"
  confirmLabel="Delete"
  cancelLabel="Cancel"
  [loading]="isDeleting"
  (onConfirm)="onConfirmDelete()"
  (onCancel)="onCancelDelete()"
></app-confirmation-dialog>

<!-- Modify Asset Modal -->
<app-modal
  [(visible)]="showModifyModal"
  header="Modify Asset Metadata"
  [width]="'900px'"
  [showFooter]="false"
  (onCancel)="closeModifyModal()"
>
  <div *ngIf="isLoadingAssetData" class="loading-container">
    <p>Loading asset data...</p>
  </div>
  <app-provider-preview-metadata
    *ngIf="!isLoadingAssetData && modifyAssetData"
    [editableMode]="true"
    [allowSaveWithoutDirty]="true"
    [assetData]="modifyAssetData"
    [assetType]="getAssetTypeForModify()"
    (formSubmit)="onModifyFormSubmit($event)"
    (formCancel)="onModifyFormCancel()"
  ></app-provider-preview-metadata>
</app-modal>
